<form (change)="saveForm()" [formGroup]="tbsRegeling">
    <div formArrayName="tbsOpbrengsten">
        <div *ngFor="let tbs of tbsOpbrengsten.controls; let i = index"
             [formGroupName]="i" class="row">
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving opbrengsten TBS' : ''"
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijTbsOpbrengsten(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="trash"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="tbsOpbrengsten.length === 0">
        <snelstart-ui-button (click)="addRijTbsOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Opbrengsten invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="tbsOpbrengsten.length > 0">
        <snelstart-ui-button (click)="addRijTbsOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Opbrengsten toevoegen
        </snelstart-ui-button>
    </div>

    <div formArrayName="tbsKosten">
        <div *ngFor="let tbs of tbsKosten.controls; let i = index"
             [formGroupName]="i" class="row">
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving kosten TBS' : ''"
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijTbsKosten(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="trash"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="tbsKosten.length === 0">
        <snelstart-ui-button (click)="addRijTbsKosten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="tbsKosten.length > 0">
        <snelstart-ui-button (click)="addRijTbsKosten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten toevoegen
        </snelstart-ui-button>
    </div>

    <div *ngIf="this.isDefAangifte">
        <div formArrayName="tbsBezittingen">
            <div *ngFor="let tbs of tbsBezittingen.controls; let i = index"
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Bezittingen TBS' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde opening' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeOpening"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde slot' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeSlot"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijTbsBezittingen(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="col-auto"
                                         icon="trash"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>

        <div *ngIf="tbsBezittingen.length === 0">
            <snelstart-ui-button (click)="addRijTbsBezittingen()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Bezitting invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="tbsBezittingen.length > 0">
            <snelstart-ui-button (click)="addRijTbsBezittingen()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Bezitting toevoegen
            </snelstart-ui-button>
        </div>


        <div formArrayName="tbsOnroerendeZaken">
            <div *ngFor="let tbs of tbsOnroerendeZaken.controls; let i = index"
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Onroerende zaak TBS' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde opening' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeOpening"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde slot' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeSlot"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijTbsOnrZaken(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="col-auto"
                                         icon="trash"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>

        <div *ngIf="tbsOnroerendeZaken.length === 0">
            <snelstart-ui-button (click)="addRijTbsOnrZaken()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Onroerende zaak invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="tbsOnroerendeZaken.length > 0">
            <snelstart-ui-button (click)="addRijTbsOnrZaken()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Onroerende zaak toevoegen
            </snelstart-ui-button>
        </div>


        <div formArrayName="tbsSchulden">
            <div *ngFor="let tbs of tbsSchulden.controls; let i = index"
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Schuld TBS' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde opening' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeOpening"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Waarde slot' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="waardeSlot"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijTbsSchulden(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="col-auto"
                                         icon="trash"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>

        <div *ngIf="tbsSchulden.length === 0">
            <snelstart-ui-button (click)="addRijTbsSchulden()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Schuld invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="tbsSchulden.length > 0">
            <snelstart-ui-button (click)="addRijTbsSchulden()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Schuld toevoegen
            </snelstart-ui-button>
        </div>

    </div>
</form>

